import { useState, useEffect } from 'react'

import { storeGet } from 'mailup-react-helpers'
import { STORE_KEY_ACCOUNT } from 'mailup-react-helpers'

import { logAppError } from 'Helpers/logger'

import noImagePreviewBackground from 'Img/no-image-preview-backgroud.png'
import { beEmailMessageApiCreateMessageThumbnail } from 'Api/beEmailMessageApi'

const useMessageThumbnail = ({ id, hasThumbnail, updateDate }) => {
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)

  const [{ url, status }, setStatus] = useState({
    url: noImagePreviewBackground,
    status: 'loading'
  })
  const handleThumb = async () => {
    if (id) {
      const ts = updateDate
        ? new Date(updateDate)
          .toISOString()
          .replace(/[-:.TZ]/g, '')
          .substring(0, 14)
        : ''
      if (hasThumbnail) {
        setStatus({
          url: `//${Domain}/messagepreview/${id}_268x321.jpg?ts=${ts}`,
          status: 'loaded'
        })
      } else {
        try {
          await beEmailMessageApiCreateMessageThumbnail(id)
          setStatus({
            url: `//${Domain}/messagepreview/${id}_268x321.jpg?ts=${ts}`,
            status: 'loaded'
          })
        } catch (error) {
          logAppError({ appError: error })
          setStatus(prev => ({
            ...prev,
            status: 'error'
          }))
        }
      }
    }
  }

  useEffect(() => {
    handleThumb()
  }, [id, hasThumbnail, updateDate])

  return [url, status]
}

export default useMessageThumbnail
